export const URL_ACTION_TRIGGER_BASE_PATH = 'url-action-trigger';
export enum UrlActionTrigger {
  IntercomOpen = 'intercom_open',
  IntercomMessage = 'intercom_message',
  PlanPickerOpen = 'plan_picker_open',
  CreateJobOpen = 'create_job_open',
}
